module.exports = __webpack_public_path__ + "img/map.aa0ee3c1.svg";